import cookie from 'js-cookie';
import { trackEvent } from './analytics';
import type { Dispatch } from '../types/app.types';
// LinkShare tracking Cookie settings
export const cookieNames = {
  SITE_ID: 'linkshareSiteID',
  DATETIME_LANDED: 'linkshareDatetimeLanded',
};
export default (orderId: string | null | undefined, dispatch: Dispatch) => {
  const linkshareSiteID: string | null | undefined = cookie && cookie.get(cookieNames.SITE_ID);
  const linkshareDatetimeLanded: string | null | undefined = cookie && cookie.get(cookieNames.DATETIME_LANDED);

  if (linkshareSiteID) {
    dispatch(
      trackEvent('Linkshare Purchase', {
        nonInteraction: true,
        siteID: linkshareSiteID,
        datetimeLanded: linkshareDatetimeLanded,
        orderId: orderId,
      })
    );
  }
};
